var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.loading)?_c('Spin',{attrs:{"fix":""}}):_c('e-charts',{attrs:{"options":_vm.options,"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }